import { ContentfulEntryType } from './contentful-entry.type';
import { TopicType } from './topic.type';

export class SubjectType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get topics(): Array<TopicType> {
    const entries: ContentfulEntryType[] = this.fields['topics'];
    let results: Array<TopicType> = [];
    for (let entry of entries) {
      results.push(new TopicType(entry));
    }
    return results;
  }

}


